module.exports = __webpack_public_path__ + "assets/img/6-5.1e82521d.png";